export const map = state => state.map.map;
export const mapError = state => state.map.mapError;
export const mapLoading = state => state.map.loading;
